import React, {useEffect, useRef, useState} from "react";
import { Box } from '@curves/ui-base';
import { HtmlFrameComponent } from "@Local/Measurement/Components/Common";
import {useMeasurementContext} from "@Local/Measurement/Context/MeasurementContext";
import useMemberInbodyApi from "@Apis/useMemberInbodyApi";
import useEmployeeInbodyApi from "@Apis/useEmployeeInbodyApi";
import {isEmpty, localUser} from "@Util/utils";
import {useSwitchDisplayMode} from "@Local/Measurement/hook/useSwitchDisplayMode";
import {MEMBER_SITE_LOGON_TYPE} from "@Constants/dataEnums";

const MeasurementResultsPage = () => {
    const {measureID} = useMeasurementContext();
    const {isTextMode, isGraphMode} = useSwitchDisplayMode();
    const {getMemberInbodyResultApi, getMemberInbodyResultPageApi} = useMemberInbodyApi();
    const {getEmployeeInbodyResultApi, getEmployeeInbodyResultPageApi} = useEmployeeInbodyApi();
    const [data, setData] = useState(null);
    const [pageData, setPageData] = useState(null);
    const currentMeasureID = useRef(measureID);

    const {logonType} = localUser.get() || {};

    const doMemberInbodyResultApi = async () => {
        if (!isEmpty(data) && currentMeasureID.current === measureID) return;
        const resp =
            logonType === MEMBER_SITE_LOGON_TYPE.MEMBER
                ? await getMemberInbodyResultApi(measureID)
                : logonType === MEMBER_SITE_LOGON_TYPE.EMPLOYEE
                    ? await getEmployeeInbodyResultApi(measureID)
                    : null;
        if (resp) {
            setData(resp);
            currentMeasureID.current = measureID;
        }
    };

    const doMemberInbodyResultPageApi = async () => {
        if (!isEmpty(pageData) && currentMeasureID.current === measureID) return;
        const resp =
            logonType === MEMBER_SITE_LOGON_TYPE.MEMBER
                ? await getMemberInbodyResultPageApi(measureID)
                : logonType === MEMBER_SITE_LOGON_TYPE.EMPLOYEE
                    ? await getEmployeeInbodyResultPageApi(measureID)
                    : null;
        if (resp) {
            setPageData(resp);
            currentMeasureID.current = measureID;
        }
    };

    useEffect(
        () => {
            if (measureID) {
                isTextMode ? doMemberInbodyResultApi(measureID) : doMemberInbodyResultPageApi(measureID);
            }
        },
        // eslint-disable-next-line
        [measureID, isTextMode],
    );

    return (
        <>
            {isGraphMode && !isEmpty(pageData) && (
                <>
                    <Box className={"container-full page-center"}>
                        <HtmlFrameComponent title={"InBody 套表"} pageUrl={pageData.pageUrl} floatButtonClass="" />
                    </Box>
                </>
            )}
        </>
    );
};

export default MeasurementResultsPage;
